import { render, staticRenderFns } from "./SoglashenieNaDolg.vue?vue&type=template&id=dabfed80&scoped=true&"
import script from "./SoglashenieNaDolg.vue?vue&type=script&lang=js&"
export * from "./SoglashenieNaDolg.vue?vue&type=script&lang=js&"
import style0 from "./SoglashenieNaDolg.vue?vue&type=style&index=0&id=dabfed80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabfed80",
  null
  
)

component.options.__file = "SoglashenieNaDolg.vue"
export default component.exports